
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","data-name":"oeamtc-icon__marker","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1a6 6 0 00-6 6c0 5 6 9 6 9s6-4 6-9a6 6 0 00-6-6zm0 8a2 2 0 112-2 2 2 0 01-2 2z"}})])
          )
        }
      }
    